import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/logo/nanoo_tv_Logo.svg'


const _hoisted_1 = {
  id: "navigation",
  class: "bg-[#fafafa] z-50 pt-[25px] pb-[18px] fixed top-0 right-0 left-0"
}
const _hoisted_2 = { class: "flex items-center justify-between mx-auto max-w-[1400px]" }
const _hoisted_3 = {
  class: "flex pr-5",
  id: "user-dropdown"
}
const _hoisted_4 = {
  key: 0,
  class: "bi-chevron-down ml-[5px] text-[#db0720]"
}
const _hoisted_5 = ["href"]
const _hoisted_6 = {
  class: "relative group pl-[20px]",
  title: 'Logged in as: ' + 'placeholder'
}

import { ref, computed, onMounted } from 'vue'
    import { usePermissionsStore } from '@/stores/PermissionsStore'
    import useContactStore from '@/utils/useContactStore'
    import fetchData from '@/model/Storage'
    import { useRoute } from 'vue-router'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'Navigation',
  setup(__props) {

    const permissionsStore = usePermissionsStore()
    const { selectedContact } = useContactStore()
    const route = useRoute()

    const hasTimesheetPermission = computed(() => {
        return permissionsStore.links.some((link) => link.href === '/timesheet')
    })

    const timesheetNavigationTarget = computed(() => {
        if (hasTimesheetPermission.value) {
            return '/timesheet'
        } else {
            // Defensively check for the existence of route and route.path
            const basePath = route && route.path ? '/' + route.path.split('/')[1] : '/'
            return basePath
        }
    })

    // Assume predefinedElements now only contains the top-level menu items without subpoints
    const predefinedElements = ref([
        { title: 'Timesheet', link: '/timesheet', subpoints: null },
        {
            title: 'Links',
            link: null,
            subpoints: [
                { title: 'Sharepoint', link: 'https://nanoo.sharepoint.com/' },
                { title: 'Dynamics', link: 'https://werft22crm.crm4.dynamics.com/' },
                { title: 'FileMaker', link: 'fmp://fms-2016.werft22.net/WerftZentrale' },
            ],
        },
        {
            title: 'Finanzdienste',
            link: null,
            subpoints: [{ title: 'VISA', link: '/visa' }],
        },
        {
            title: 'Sales',
            link: null,
            subpoints: [
                { title: 'Offertentool', link: '/offers' },
                { title: 'Adressbuch', link: '/contacts', method: clearContactForm },
            ],
        },
        {
            title: 'Extern',
            link: null,
            subpoints: [
                { title: 'TIPTEL', link: '/tiptel' },
                { title: 'Admin', link: '/admin' },
                { title: 'Project NICE', link: '/nice' },
            ],
        },
        {
            title: 'Media',
            link: '/media',
            subpoints: [{ title: 'Video Player', link: '/media/player' }],
        },
    ])

    // Fetch user links on component mount
    // this has to be done in the setup function
    // because the navigation gets loaded as one of the first components
    onMounted(() => {
        permissionsStore.fetchUserLinks()
        console.log(permissionsStore.links)
    })

    // Computed property to get the navbar elements based on user permissions
    const navbarElements = computed(() => {
        const userLinkHrefs = permissionsStore.links.map((link) => link.href)
        return predefinedElements.value.reduce((acc, elem) => {
            if (!elem.subpoints) {
                // Directly include top-level menu items if the user has the permission
                if (userLinkHrefs.includes(elem.link)) {
                    acc.push(elem)
                }
            } else {
                // Filter subpoints based on user permissions
                const permittedSubpoints = elem.subpoints.filter((subpoint) =>
                    userLinkHrefs.includes(subpoint.link)
                )

                // Only include top-level menu items if there are permitted subpoints
                if (permittedSubpoints.length > 0) {
                    acc.push({ ...elem, subpoints: permittedSubpoints })
                }
            }
            return acc
        }, [])
    })

    function clearContactForm() {
        selectedContact.value = {}
        selectedContact.value.person = {}
        selectedContact.value.organisation = {}
        selectedContact.value.billing = {}
    }

    async function logout() {
        console.log('logout')
        await fetchData({ method: 'DELETE', endpoint: 'logout' })
    }

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        id: "logo-link",
        to: timesheetNavigationTarget.value
      }, {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
          _createElementVNode("img", {
            src: _imports_0,
            alt: "nanoo.tv",
            id: "logo",
            class: "w-[190px] lg:w-[210px] pl-5"
          }, null, -1)
        ]))]),
        _: 1
      }, 8, ["to"]),
      _createElementVNode("nav", null, [
        _createElementVNode("ul", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navbarElements.value, (elem, index) => {
            return (_openBlock(), _createBlock(_component_v_menu, {
              "open-on-hover": "",
              key: index
            }, {
              activator: _withCtx(({ props }) => [
                _createElementVNode("h2", _mergeProps({ ref_for: true }, props, { class: "pl-[20px]" }), [
                  _createVNode(_component_router_link, {
                    to: elem.link ? elem.link : ''
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(elem.title) + " ", 1),
                      (elem.subpoints)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_4))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ], 16)
              ]),
              default: _withCtx(() => [
                (elem.subpoints)
                  ? (_openBlock(), _createBlock(_component_v_list, {
                      key: 0,
                      id: "subpointsList"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(elem.subpoints, (item, index) => {
                          return (_openBlock(), _createBlock(_component_v_list_item, {
                            key: index,
                            onClick: item.method
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("a", {
                                    href: item.link,
                                    class: "pt-[10px] pr-[20px] pb-[10px] pl-[10px]"
                                  }, [
                                    _cache[3] || (_cache[3] = _createElementVNode("i", { class: "bi-dash ml-[5px] pr-[10px] text-[#db0720]" }, null, -1)),
                                    _createTextVNode(" " + _toDisplayString(item.title), 1)
                                  ], 8, _hoisted_5)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        }), 128))
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1024))
          }), 128)),
          _createVNode(_component_v_menu, {
            "open-on-hover": "",
            id: "language"
          }, {
            activator: _withCtx(({ props }) => [
              _createElementVNode("h2", _mergeProps(props, {
                class: "pl-[20px] cursor-pointer",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (
                                    _ctx.$i18n.locale == 'en-GB'
                                        ? (_ctx.$i18n.locale = 'de-CH')
                                        : (_ctx.$i18n.locale = 'en-GB')
                                ))
              }), [
                _createTextVNode(_toDisplayString(_ctx.$i18n.locale == 'en-GB' ? 'EN' : 'DE') + " ", 1),
                _cache[4] || (_cache[4] = _createElementVNode("i", { class: "bi-arrow-repeat ml-[5px] text-[#db0720]" }, null, -1))
              ], 16)
            ]),
            _: 1
          }),
          _createElementVNode("li", _hoisted_6, [
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (logout())),
              id: "logout"
            }, "Logout")
          ])
        ])
      ])
    ])
  ]))
}
}

})